// Contactus.js - Updated with Custom Contact Form
import React, { useState, useEffect } from 'react'
import Topnavbar from '../Header-pages/Topnavbar'
import Navbar from '../Header-pages/Navbar'
import Footer from '../Header-pages/Footer'
import '../Css/Contactus.css'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { 
  faBuilding, 
  faPhone, 
  faEnvelope, 
  faClock,
  faMapMarkerAlt,
  faGlobe,
  faMap,
  faDirections,
  faExternalLinkAlt,
  faUser,
  faComment,
  faTag
} from '@fortawesome/free-solid-svg-icons'
import { toast, ToastContainer } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
import { API_URL } from '../utils/Function'
import { useNavigate, useLocation } from 'react-router-dom'

export default function Contactus() {
  const navigate = useNavigate();
  const location = useLocation();
  
  const companyLocation = {
    address: "2nd Floor, VSB EDIFICE, 303, Bazaar St, Pernambut, Tamil Nadu 635810",
    address2: "",
    lat: 12.9364255,
    lng: 78.7192372
  };

  // Plan info from navigation state
  const [planInfo, setPlanInfo] = useState({
    productName: '',
    planName: '',
    planType: ''
  });

  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    message: '',
    plan_name: '',
    product_name: '',
    plan_type: ''
  });

  const [loading, setLoading] = useState(false);
  const [formErrors, setFormErrors] = useState({});
  const [touched, setTouched] = useState({});

  // Capture plan info from navigation
  useEffect(() => {
    if (location.state?.planInfo) {
      setPlanInfo(location.state.planInfo);
      
      // Pre-fill message with plan information
      setFormData(prev => ({
        ...prev,
        plan_name: location.state.planInfo.planName || '',
        product_name: location.state.planInfo.productName || '',
        plan_type: location.state.planInfo.planType || '',
        message: `I'm interested in the ${location.state.planInfo.planName} plan for ${location.state.planInfo.productName}. Please provide more information about pricing and features.`
      }));
    }
  }, [location.state]);

  // Validation rules
  const validateField = (name, value) => {
    switch (name) {
      case 'name':
        if (!value.trim()) return 'Name is required';
        if (value.trim().length < 2) return 'Name must be at least 2 characters';
        return '';
        
      case 'email':
        if (!value.trim()) return 'Email is required';
        if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value)) return 'Please enter a valid email address';
        return '';
        
      case 'phone':
        if (!value.trim()) return 'Phone number is required';
        if (!/^[\+]?[1-9][\d]{0,15}$/.test(value.replace(/[\s\-\(\)]/g, ''))) return 'Please enter a valid phone number';
        return '';
        
      case 'message':
        if (!value.trim()) return 'Message is required';
        if (value.trim().length < 10) return 'Message must be at least 10 characters';
        return '';
        
      default:
        return '';
    }
  };

  const validateForm = () => {
    const errors = {};
    
    // Only validate required fields (not plan fields)
    const requiredFields = ['name', 'email', 'phone', 'message'];
    
    requiredFields.forEach(key => {
      const error = validateField(key, formData[key]);
      if (error) errors[key] = error;
    });
    
    setFormErrors(errors);
    return Object.keys(errors).length === 0;
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    
    // Mark field as touched
    setTouched(prev => ({ ...prev, [name]: true }));
    
    setFormData(prev => ({ ...prev, [name]: value }));
    
    // Real-time validation
    const error = validateField(name, value);
    setFormErrors(prev => ({
      ...prev,
      [name]: error
    }));
  };

  const handleBlur = (e) => {
    const { name, value } = e.target;
    setTouched(prev => ({ ...prev, [name]: true }));
    
    const error = validateField(name, value);
    setFormErrors(prev => ({
      ...prev,
      [name]: error
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    // Mark required fields as touched
    const requiredFields = ['name', 'email', 'phone', 'message'];
    const allTouched = {};
    requiredFields.forEach(key => {
      allTouched[key] = true;
    });
    setTouched(allTouched);
    
    // Validate form
    if (!validateForm()) {
      toast.error('Please fix the errors in the form');
      return;
    }

    setLoading(true);

    try {
      // Prepare data with plan information
      const submitData = {
        name: formData.name,
        email: formData.email,
        phone: formData.phone,
        message: formData.message,
        plan_name: planInfo.planName || '',
        product_name: planInfo.productName || '',
        plan_type: planInfo.planType || '',
        source: planInfo.planName ? 'plan_inquiry' : 'contact_form'
      };

      const response = await fetch(`${API_URL}/contact.php/post`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(submitData)
      });

      const data = await response.json();

      if (data.success) {
        toast.success('Message sent successfully! We will get back to you soon.');
        // Reset form
        setFormData({
          name: '',
          email: '',
          phone: '',
          message: '',
          plan_name: '',
          product_name: '',
          plan_type: ''
        });
        setPlanInfo({
          productName: '',
          planName: '',
          planType: ''
        });
        setTouched({});
      } else {
        toast.error(data.error || 'Failed to send message');
      }
    } catch (error) {
      console.error('Error sending message:', error);
      toast.error('An error occurred while sending your message');
    } finally {
      setLoading(false);
    }
  };

  const openInGoogleMaps = () => {
    window.open(`https://www.google.com/maps/search/?api=1&query=${encodeURIComponent('Safpro Technology Solutions Vellore')}`, '_blank');
  };

  const openInMapsApp = () => {
    window.open(`https://www.google.com/maps?q=${companyLocation.lat},${companyLocation.lng}`, '_blank');
  };

  // Helper function to get input class
  const getInputClass = (fieldName) => {
    if (!touched[fieldName]) {
      return 'form-input';
    }
    
    if (formErrors[fieldName]) {
      return 'form-input is-invalid';
    } else if (formData[fieldName] && formData[fieldName].toString().trim() !== '') {
      return 'form-input is-valid';
    }
    
    return 'form-input';
  };

  return (
    <>
      <Topnavbar />
      <Navbar />
      
      {/* Hero Section */}
      <div className='contactus-hero-section'>
        <img 
          src='/images/Productview.jpg' 
          alt='Contact Us' 
          className='contactus-hero-image'
        />
        <div className='contactus-hero-overlay'>
          <div className='contactus-hero-breadcrumbs'>
            <a onClick={()=>navigate('/')} style={{cursor:'pointer',color:'#fff'}}>Home</a>
            <span className='contactus-breadcrumb-separator'>/</span>
            <span className='contactus-breadcrumb-current' style={{cursor:'pointer',color:'#fff'}}>Contact Us</span>
          </div>
          
          <div className='contactus-hero-content'>
            <h1>Get In Touch</h1>
            <p>We're here to help you with innovative technology solutions. Reach out to us for any inquiries or support.</p>
          </div>
        </div>
      </div>

      {/* Plan Info Banner */}
      {planInfo.planName && (
        <div className="plan-info-banner">
          <div className="container">
            <div className="plan-banner-content">
              <FontAwesomeIcon icon={faTag} className="plan-icon" />
              <div className="plan-details">
                <h4>Plan Inquiry: {planInfo.planName}</h4>
                <p>Product: {planInfo.productName}</p>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Main Contact Content */}
      <div className="contactus-container">
        <div className="contactus-content">
          {/* Contact Information Section */}
          <div className="contact-info-section">
            <div className="contact-info-header">
              <h2>Contact Information</h2>
              <p>Feel free to reach out to us through any of the following channels</p>
            </div>

            {/* Address Section */}
            <div className="contact-subsection">
              <h3 className="contact-subsection-heading">Address</h3>
              <div className="contact-info-grid">
                <div className="contact-info-card">
                  <div className="contact-icon-wrapper">
                    <FontAwesomeIcon icon={faBuilding} className="contact-icon" />
                  </div>
                  <div className="contact-details">
                    <h3>Head Office</h3>
                    <p>{companyLocation.address}</p>
                  </div>
                </div>

                <div className="contact-info-card">
                  <div className="contact-icon-wrapper">
                    <FontAwesomeIcon icon={faBuilding} className="contact-icon" />
                  </div>
                  <div className="contact-details">
                    <h3>Our Branch</h3>
                    <p> Aratt Grija Tower, Lake View County Approach Rd,  AECS C Block, Begur, Bengaluru, Karnataka 560114</p>
                  </div>
                </div>
              </div>
            </div>

            {/* Email Section */}
            <div className="contact-subsection">
              <h3 className="contact-subsection-heading">Email</h3>
              <div className="contact-info-grid">
                <div className="contact-info-card">
                  <div className="contact-icon-wrapper">
                    <FontAwesomeIcon icon={faEnvelope} className="contact-icon" />
                  </div>
                  <div className="contact-details">
                    <h3>Email Address</h3>
                    <p><a href="mailto:info@safprotech.com">info@safprotech.com</a></p>
                  </div>
                </div>
              </div>
            </div>

            {/* Working Hours Section */}
            <div className="contact-subsection">
              <h3 className="contact-subsection-heading">Working Hours</h3>
              <div className="contact-info-grid">
                <div className="contact-info-card">
                  <div className="contact-icon-wrapper">
                    <FontAwesomeIcon icon={faClock} className="contact-icon" />
                  </div>
                  <div className="contact-details">
                    <h3>Business Hours</h3>
                    <p>Monday - Friday: 10:30 AM - 7:30 PM</p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Modern Map Section */}
          <div className="modern-map-section">
            <div className="map-header">
              <h2>Find Our Location</h2>
            </div>
            
            <div className="modern-map-container">
              <div className="map-wrapper">
                {/* Simple map without satellite imagery */}
                <iframe
                  src={`https://maps.google.com/maps?q=${companyLocation.lat},${companyLocation.lng}&z=16&output=embed`}
                  width="100%"
                  height="100%"
                  style={{ border: 0 }}
                  allowFullScreen=""
                  loading="lazy"
                  referrerPolicy="no-referrer-when-downgrade"
                  title="Safpro Technology Solutions Location"
                  className="modern-map-iframe"
                ></iframe>
                
                {/* Map Overlay Controls */}
                <div className="map-overlay-controls">
                  <button 
                    className="map-control-btn directions-btn"
                    onClick={openInGoogleMaps}
                  >
                    <FontAwesomeIcon icon={faDirections} />
                    <span>Get Directions</span>
                  </button>
                  <button 
                    className="map-control-btn open-map-btn"
                    onClick={openInMapsApp}
                  >
                    <FontAwesomeIcon icon={faMap} />
                    <span>Open in Maps</span>
                  </button>
                </div>
              </div>
            </div>
          </div>

          {/* Contact Form Section */}
          <div className="contact-form-section">
            <div className="form-header">
              <h2>Send Us a Message</h2>
              <p>Have questions? We'd love to hear from you.</p>
            </div>
            
            <ToastContainer 
              position="top-center" 
              autoClose={3000}
              hideProgressBar={false}
              newestOnTop
              closeOnClick
              rtl={false}
              pauseOnFocusLoss
              draggable
              pauseOnHover
            />

            {/* Plan Info Hint */}
            {planInfo.planName && (
              <div className="form-hint">
                <strong>Note:</strong> You're inquiring about the <strong>{planInfo.planName}</strong> plan for <strong>{planInfo.productName}</strong>. This information has been pre-filled in your message.
              </div>
            )}

            <div className="form-container">
              <div className="google-form-wrapper">
                <form onSubmit={handleSubmit} className="application-form" noValidate>
                  {/* Personal Information Section */}
                  <div className="form-section">
                    <h3 className="section-title">Personal Information</h3>
                    <div className="form-row">
                      <div className="form-group">
                        <label className="form-label">
                          Full Name <span className="required">*</span>
                        </label>
                        <div className="input-with-icon">
                          <FontAwesomeIcon icon={faUser} className="input-icon" />
                          <input
                            type="text"
                            name="name"
                            value={formData.name}
                            onChange={handleInputChange}
                            onBlur={handleBlur}
                            className={getInputClass('name')}
                            placeholder="Enter your full name"
                            required
                          />
                        </div>
                        {touched.name && formErrors.name && (
                          <div className="invalid-feedback">{formErrors.name}</div>
                        )}
                      </div>
                      
                      <div className="form-group">
                        <label className="form-label">
                          Email <span className="required">*</span>
                        </label>
                        <div className="input-with-icon">
                          <FontAwesomeIcon icon={faEnvelope} className="input-icon" />
                          <input
                            type="email"
                            name="email"
                            value={formData.email}
                            onChange={handleInputChange}
                            onBlur={handleBlur}
                            className={getInputClass('email')}
                            placeholder="Enter your email"
                            required
                          />
                        </div>
                        {touched.email && formErrors.email && (
                          <div className="invalid-feedback">{formErrors.email}</div>
                        )}
                      </div>
                    </div>

                    <div className="form-row">
                      <div className="form-group">
                        <label className="form-label">
                          Phone <span className="required">*</span>
                        </label>
                        <div className="input-with-icon">
                          <FontAwesomeIcon icon={faPhone} className="input-icon" />
                          <input
                            type="tel"
                            name="phone"
                            value={formData.phone}
                            onChange={handleInputChange}
                            onBlur={handleBlur}
                            className={getInputClass('phone')}
                            placeholder="Enter your phone number"
                            required
                          />
                        </div>
                        {touched.phone && formErrors.phone && (
                          <div className="invalid-feedback">{formErrors.phone}</div>
                        )}
                      </div>
                    </div>
                  </div>

                  {/* Message Section */}
                  <div className="form-section">
                    <h3 className="section-title">Your Message</h3>
                    <div className="form-group">
                      <label className="form-label">
                        Message <span className="required">*</span>
                      </label>
                      <div className="textarea-with-icon">
                        <FontAwesomeIcon icon={faComment} className="textarea-icon" />
                        <textarea
                          name="message"
                          value={formData.message}
                          onChange={handleInputChange}
                          onBlur={handleBlur}
                          className={getInputClass('message')}
                          placeholder="Tell us how we can help you..."
                          rows="6"
                          required
                        />
                      </div>
                      {touched.message && formErrors.message && (
                        <div className="invalid-feedback">{formErrors.message}</div>
                      )}
                    </div>
                  </div>

                  {/* Form Actions */}
                  <div className="form-actions">
                    <button
                      type="submit"
                      className="submit-button"
                      disabled={loading}
                    >
                      {loading ? (
                        <>
                          <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                          Sending...
                        </>
                      ) : (
                        'Send Message'
                      )}
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </>
  )
}